import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__edUpsell) {
  window.__edUpsell = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-ed-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-ed-upsell-add');
    btn.setAttribute('aria-busy', 'true');
    const label = btn.querySelector('.ed-up__add-label');
    if (label) label.textContent = 'Adicionando…';
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') }),
      }).then((r) => r.json());
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'ed-upsell', sections: res.sections, didError: !!res.status, itemCount: 1 },
      });
    } catch (err) {
      deferred.reject(err);
      location.reload();
    }
  });
}
